import moment = require('moment');
import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListProdPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {
    const performanceDate = moment(props.performance.date);
    const mapKey = props.performance.specialFeature?.toLowerCase().trim();
    const specialFeatureMapping = props.specialFeatureMap?.get(mapKey) || null;
    return (
        <li className="ace-production-row stack-sm-mobile">
            <div className="flex align-items-center">
                {
                    (props.performance.imageUrl && props.performance.imageUrl !== '') ?
                        <div className="ace-production-image">
                            <div className="ace-production-image-inner">
                                <img src={`${props.performance.imageUrl}?width=50`} alt="" />
                            </div>
                        </div>
                        :
                        null
                }
                <h3 className="ace-production-info-title">{
                    props.performance.productionDetailPageLink != null && props.performance.productionDetailPageLink.length > 0 ?
                        <a target="_blank" href={props.performance.productionDetailPageLink}>{props.performance.title + (props.performance.IsDroppable ? "*" : "")}</a>
                        :
                        props.performance.title
                }</h3>
                {specialFeatureMapping &&
                    <span>{`${specialFeatureMapping.symbol}`}</span>
                }
            </div>
            <p className="ace-production-date">
                <span>{performanceDate.format('ddd, MMM D, YYYY')}</span>
                <span>{props.performance.performanceTimeString}</span>
                
            </p>
        </li>
    );
}

export default ListProdPerformanceView;